<template>
  <div>
    <el-card style="width:100%;height: 110px" v-loading="loading">
      <div slot="header" class="card-header">
        <i class="el-icon-font el-icon-shebeizuguanli el-icon--left"></i>抢单时长
      </div>
      <el-form :inline="true" :rules="robdurationRules" :model="dataInfo" ref="ruleForm" label-width="100px">
        <el-form-item label="抢单时长" prop="robduration">
          <el-input-number v-model="dataInfo.robduration" :precision="0" :step="1" style="width:260px"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()" :loading="saving">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'robduration',
  props: ["funcs"],
  data () {
    return {
      editVisible: false,
      dataInfo: {
      },
      robdurationRules: {
        robduration: [
          { required: true, message: '请输入抢单时长', trigger: 'blur' },
          { type: 'number', message: '抢单时长必须为数字值' }
        ],
      },
      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadOtherHours()
    },
    //从后台查询其他工时
    loadOtherHours () {
      this.loading = true
      this.$ajax.get('/buss/otherhours/selectRobduration').then(msg => {
        this.dataInfo = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    //保存其他工时
    submitForm () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let url = "/buss/otherhours/editRobduration";
          this.saving = true
          this.$ajax.post(url, this.dataInfo).then(msg => {
            this.saving = false
            this.loadOtherHours()
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
